export default {
  name: "messageReceiverMixin",
  data(){
    return {
      processing:false
    }
  },
  methods: {
    messageReceived(receivedMessage) {
      try {
        const message = receivedMessage.data
          ? JSON.parse(receivedMessage.data)
          : null;

        if (message && message.from && message.from == "wtfApp") {

          if (message.value !== undefined) {
            this.saveTrackingStatus(message.value == "authorized"); //
          } else if (
            message.IsApplePayAvailable !== undefined ||
            message.IsGooglePayAvailable !== undefined
          ) {
            this.saveApplePayAvailibility(message.IsApplePayAvailable);
            this.saveGooglePayAvailibility(message.IsGooglePayAvailable);
          } else if (message.paymentMethod !== undefined) {
            // need to add processingPayment to lock the payment process
            this.$emit("PROCESS_NATIVE_PAY", message.paymentMethod);
          }
          else if (message.failed_payment !== undefined){
            
            const full_message =
            "<p><i class='k-icon-sadface' style='color:" +
            this.staticColor.red +
            "' ></i></p><p>" +
            this.$t('generic_error.stripe_payment_failed') +
            "</p>";

            const options = {
              html: true,
              animation: "fade",
              type: "basic",
              backdropClose: false,
              customClass: "confirm",
              okText: "OK",
            };
            this.$dialog.alert(full_message, options)
            this.$emit("NATIVE_PAY_FAILED");

          }else if (message.channel  !== undefined){
            this.saveChannel(message.channel)
          }
          else if (message.playerId  !== undefined){
            this.saveOneSignalPlayerId(message.playerId)

            if(this.user){
              this.saveOneSignalUserId(this.user.id)
            }
          }else if (message.action != undefined && message.action == 'login'){
            this.$emit("SOCIAL_LOGIN_FIRED", message.data);
          }
        }
      } catch (ex) {}
    },
    sendMessage(message) {
      if(window.ReactNativeWebView){
        window.ReactNativeWebView.postMessage(JSON.stringify(message))
      }
    },
  },
};
